"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolTip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _ToolTip = require("./ToolTip.styled");
var _hooks = require("../../hooks");
var _excluded = ["targetElement", "message", "placement", "displayTooltip", "mode", "noPointerEvent", "fade"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// eslint-disable-next-line react/display-name
var ToolTip = exports.ToolTip = (0, _react.memo)(function (_ref) {
  var targetElement = _ref.targetElement,
    message = _ref.message,
    placement = _ref.placement,
    displayTooltip = _ref.displayTooltip,
    mode = _ref.mode,
    noPointerEvent = _ref.noPointerEvent,
    fade = _ref.fade,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var isDirectorLite = (0, _hooks.useStudioLiteContext)();
  var elementId = "tooltip_".concat(targetElement);
  var isLight = mode === 'light' && !isDirectorLite;
  var selectedToolTipStyle = isLight ? _ToolTip.ToolTipStyle : _ToolTip.ToolTipStyleDark;
  if (!displayTooltip) return null;
  return _react["default"].createElement(_ToolTip.StyledToolTip, (0, _extends2["default"])({
    id: elementId,
    placement: placement,
    style: selectedToolTipStyle,
    target: targetElement,
    "data-testid": elementId,
    isLight: isLight,
    $noPointerEvent: noPointerEvent,
    fade: fade
  }, rest), message);
});
ToolTip.propTypes = {
  fade: _propTypes.bool,
  mode: _propTypes.string,
  placement: _propTypes.string,
  displayTooltip: _propTypes.bool,
  noPointerEvent: _propTypes.bool,
  message: _propTypes.string.isRequired,
  targetElement: _propTypes.string.isRequired
};
ToolTip.defaultProps = {
  placement: 'bottom',
  displayTooltip: true,
  mode: 'light',
  noPointerEvent: false
};